import { useContext, useEffect, useState } from "react";
import FormControl from "@mui/material/FormControl";
import React from "react";
import DatepickerFilter from "./datepicker";
import { Box, Grid, Typography } from "@mui/material";
import CardSys from "../cardSys";
import SubTitleCard from "../cardSys/subTitle";
import SelectEnterprise from "../selectEnterpriseN";
import { api } from "../../services/api";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import { AuthContext } from "../../contexts/AuthContext";
import TitleDashboard from "../generic/dashBoardTitle";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function CardFilter({ children, hadleFilterParent, filter, ...props }) {
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const [groupsSelected, setGroupsSelected] = useState([]);
  const { user } = useContext(AuthContext)
  const [report1, setReport1] = useState([])
  const [report2, setReport2] = useState([])
  const [report3, setReport3] = useState([])
  const [resumo, setResumo] = useState([])

  useEffect(() => {
    if (user?.id_client != 25886008 && !!user?.id_client) {
      // handleFilter()
    }
  }, [user?.id_client])

  const handleFilter = async (enterpriseSelectedObj = filter?.enterpriseSelected) => {
    if ((typeof enterpriseSelectedObj === 'undefined') || (enterpriseSelectedObj == 'undefined')) {
      return
    } 
    try {
      var enterpriseSelected = enterpriseSelectedObj?.map(a => a.id);
    } catch {
      return
    }


    if (Object.keys(enterpriseSelected).length) {
      let data = {
        id_client: enterpriseSelected
      }
      hadleFilterParent({ enterpriseSelected: enterpriseSelected, dateStart: data.begin, dateEnd: data.end });
      handleLoading(true);
      getFinancial(data, enterpriseSelected)
      getBaixas(data, enterpriseSelected)
      getAcordos(data, enterpriseSelected)
      getResumo(data, enterpriseSelected)
    }


  };

  function handleDate(date) {
    const dateSpli = date.split("-")
    return dateSpli[2] + "-" + dateSpli[1] + "-" + dateSpli[0]
  }

  useEffect(() => {
    if (report1.length > 0) {
      let data = {
        report1,
        ...(filter?.data?.report2),
        ...(filter?.data?.report3),
        ...(filter?.data?.resumo),
      }
      hadleFilterParent({ enterpriseSelected: filter?.enterpriseSelected, dateStart: filter?.dateStart, dateEnd: filter?.dateEnd, data });
    }
    if (report2.length > 0) {
      let data = {
        ...(filter?.data?.report1),
        report2,
        ...(filter?.data?.report3),
        ...(filter?.data?.resumo),
      }
      hadleFilterParent({ enterpriseSelected: filter?.enterpriseSelected, dateStart: filter?.dateStart, dateEnd: filter?.dateEnd, data });
    }
    if (report3.length > 0) {
      let data = {
        ...(filter?.data?.report1),
        ...(filter?.data?.report2),
        report3,
        ...(filter?.data?.resumo),
      }
      hadleFilterParent({ enterpriseSelected: filter?.enterpriseSelected, dateStart: filter?.dateStart, dateEnd: filter?.dateEnd, data });
    }
    if (resumo.length > 0) {
      let data = {
        ...(filter?.data?.report1),
        ...(filter?.data?.report2),
        ...(filter?.data?.report3),
        ...resumo,
      }
      hadleFilterParent({ enterpriseSelected: filter?.enterpriseSelected, dateStart: filter?.dateStart, dateEnd: filter?.dateEnd, data });
    }

    if (report1.length > 0 && report2.length > 0 && report3.length > 0) {
      let data = {
        report1,
        report2,
        report3,
        resumo
      }
      hadleFilterParent({ enterpriseSelected: filter?.enterpriseSelected, dateStart: filter?.dateStart, dateEnd: filter?.dateEnd, data });
    }

  }, [report1, report2, report3, resumo])

  const getFinancial = async (data) => {

    try {
      const { data: response } = await api({
        method: "POST",
        url: "/source/dashboard/financial",
        data
        
      });
      setReport1(response)

    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
  }

  const getBaixas = async (data) => {

    try {
      const { data: response } = await api({
        method: "POST",
        url: "/source/dashboard/baixas",
        data
      });
      let dados = {
        ...(filter?.data),
        report2: response
      }
      setReport2(response)
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
  }

  const getAcordos = async (data) => {
    try {
      const { data: response } = await api({
        method: "POST",
        url: "/source/dashboard/acordos",
        data
      });
      let dados = {
        ...(filter?.data),
        report3: response
      }
      setReport3(response)

    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
  }

  const getResumo = async (data, enterpriseSelected) => {
    try {
      const idClient = enterpriseSelected
      let data = {
        id_client: idClient
      }
      const { data: response } = await api({ method: 'POST', url: '/source/resumo', data });
      setResumo(response)
      handleLoading(false);

    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }

  }

  return (
    <CardSys>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs={12} sm={12} md={6} >
          <TitleDashboard >

          </TitleDashboard>
        </Grid>
        {user?.id_client != 0 ? (
          <Grid item xs={12} sm={12} md={6}>
            <Box sx={{ display: "flex", alignItems: "center", marginTop: "8px" }}>
              <SubTitleCard>Credor:</SubTitleCard>
              <FormControl
                size={"small"}
                sx={{ width: "100%", paddingLeft: "10px" }}
              >
                <SelectEnterprise
                  value={groupsSelected}
                  color="blackInput"
                  handleSelected={(value) => { setGroupsSelected(value); hadleFilterParent({ enterpriseSelected: value }); handleFilter(value) }}
                ></SelectEnterprise>
              </FormControl>
            </Box>
          </Grid>
        ) : null}
      </Grid>
    </CardSys >
  );
}
